import React, { useState, useEffect } from "react";
import { checkResult, createFilePath } from "@/common";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import BraftEditor from "braft-editor";
import { Modal, Descriptions, Divider, Button, Icon, Collapse } from "antd";
import "./style.less";
import ecology from "./images/ecology.jpg";
import precise from "./images/precise.jpg";
import major from "./images/major.jpg";
import digitize from "./images/digitize.jpg";
import normal from "./images/normal.jpg";
import industry from "./images/industry.jpg";
import market from "./images/market.jpg";
import capital from "./images/capital.jpg";
import technology from "./images/technology.jpg";

import button_close from "./images/button_close.png";
const { Panel } = Collapse;

function callback(key) {
    console.log(key);
}
const NAME = "projectService";
const App = () => {
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
    const { title = "", show, hide, width = 1095, height = 770, ServerImg } = modalProps;
    return (
        <Modal
            visible={show}
            width={width}
            height={height}
            maskClosable={false}
            onCancel={hide}
            footer={false}
            className="modal-windows"
        >
            <div className="serviceBg">
                {ServerImg == 'ecology' &&
                    <p className="serviceTitle">生态化-落地项目育成工厂</p>}
                {ServerImg == 'precise' &&
                    <p className="serviceTitle">精准化-供需对接推介活动</p>}
                {ServerImg == 'major' &&
                    <p className="serviceTitle">专业化-诊断评价策划业务</p>}
                {ServerImg == 'digitize' &&
                    <p className="serviceTitle">数字化-云网智能服务平台</p>}
                {ServerImg == 'normal' &&
                    <p className="serviceTitle">常态化-共建科创实体机构</p>}
                {ServerImg == 'industry' &&
                    <p className="serviceTitle">产业合作</p>}
                {ServerImg == 'market' &&
                    <p className="serviceTitle">市场合作</p>}
                {ServerImg == 'capital' &&
                    <p className="serviceTitle">资本合作</p>}
                {ServerImg == 'technology' &&
                    <p className="serviceTitle">技术合作</p>}
                <div className="serviceImg">
                    {ServerImg == 'ecology' &&
                        <img src={ecology}></img>}
                    {ServerImg == 'precise' &&
                        <img src={precise}></img>}
                    {ServerImg == 'major' &&
                        <img src={major}></img>}
                    {ServerImg == 'digitize' &&
                        <img src={digitize}></img>}
                    {ServerImg == 'normal' &&
                        <img src={normal}></img>}
                    {ServerImg == 'industry' &&
                        <img src={industry}></img>}
                    {ServerImg == 'market' &&
                        <img src={market}></img>}
                    {ServerImg == 'capital' &&
                        <img src={capital}></img>}
                    {ServerImg == 'technology' &&
                        <img src={technology}></img>}
                </div>
                <div className="button_close">
                    <img src={button_close} alt="关闭" onClick={hide} /></div>
            </div>
        </Modal>
    );
}

export default App;